import axios from "axios";
import { IDM_SERVER_BASE_URL } from "../Constants";
import EventBus from "../Components/CommonComponent/EventBus";

export const API_URL = IDM_SERVER_BASE_URL + "/v2/api";

class PartnerService {
    getPartners = async () => {
        const response = await axios.get(`${API_URL}/Partners`);

        if (response.data.response == null) {
            throw new Error(response.data.errors?.[0]?.message || "Request failed.");
        }

        return response.data.response;
    };

    GetPartnersPerPage = async (searchDTO) => {
        var request = {
            request: searchDTO,
        };
        const response = await axios.post(`${API_URL}/PartnerSearch`,
            request,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        if (response.status === 401) {
            EventBus.dispatch("Logout");
        }

        if (response.data.errors != null && response.data.errors.length != 0) {
            if (response.data.errors[0].message == "Tenant not selected") {
                EventBus.dispatch("SelectTenant");
            }
        }

        if (response.data.response == null) {
            throw new Error(response.data.errors?.[0]?.message || "Request failed.");
        }

        return response.data.response;
    }

    registerPartner = async (registerPartnerDTO) => {
        const iDMRequest = {
            Request: registerPartnerDTO,
        };
        const response = await axios.post(
            `${API_URL}/Partner`,
            iDMRequest,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        return response.data;
    };
    updatePartnerDetails = async (countryId, partnerId, updatePartnerDTO) => {
        const iDMRequest = {
            Request: updatePartnerDTO,
        };
        const response = await axios.put(
            `${API_URL}/Partner/${countryId}/${partnerId}`,
            iDMRequest,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        return response.data;
    };
    deletePartner = async () => {
        axios.defaults.withCredentials = true;
        const response = await axios.delete(
            `${API_URL}/Partner`,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            },
            { withCredentials: true }
        );

        return response.data;
    };

    GetCountries = async () => {
        axios.defaults.withCredentials = true;
        const response = await axios.get(
            `${API_URL}/Country`,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            },
            { withCredentials: true }
        );

        return response.data;
    };

    GetPartner = async (countryId, partnerId) => {
        const response = await axios.get(
            `${API_URL}/Partner/${countryId}/${partnerId}`,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        return response.data;
    };

    BulkPartnerDelete = async (bulkDeleteDTO) => {
        var request = {
            request: bulkDeleteDTO,
        };

        const response = await axios.post(
            `${API_URL}/BulkDeletePartner`,
            request,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    };
}

export default new PartnerService();
